import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/cookie-policy/page.tsx");
